import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import '@/http'
import VueCodemirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import XEUtils from 'xe-utils'
import VXEUtils from 'vxe-utils'
import * as validate from '@/utils/index'


Vue.use(VueCodemirror)
Vue.use(XEUtils, VXEUtils)
import router from './router'


Vue.use(ElementUI);

Vue.config.productionTip = false
Vue.prototype.$validate = validate

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
